var $56f7d9be41e5dc75$exports = {};
$56f7d9be41e5dc75$exports = {
  "help": "\u041F\u043E\u043C\u043E\u0449",
  "info": "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"
};
export { $56f7d9be41e5dc75$exports as default };